import { COLOR, FONT_SIZE, mq } from "@dmm-com/rocket-web-ui-library";
import styled from "@emotion/styled";
import { GLOBAL_NAVI_FOOTER_HEIGHT } from "~/styles/layout";
import { ROOT_PADDING } from "~/styles/padding";

export const Footer = styled.footer`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: ${ROOT_PADDING.PC}px;
  background-color: ${COLOR.GRAY100.code};

  ${mq.tablet} {
    padding: ${ROOT_PADDING.PC}px ${ROOT_PADDING.PC}px calc(${ROOT_PADDING.PC}px + ${GLOBAL_NAVI_FOOTER_HEIGHT}px);
  }

  ${mq.sp} {
    padding: ${ROOT_PADDING.SP}px ${ROOT_PADDING.SP}px calc(${ROOT_PADDING.SP}px + ${GLOBAL_NAVI_FOOTER_HEIGHT}px);
  }
`;

export const NavLinkWrapper = styled.nav`
  margin-bottom: 8px;
`;

export const UlNavList = styled.ul`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`;

export const LiNavItem = styled.li`
  margin-bottom: 8px;
  &:nth-of-type(n + 2) {
    margin-left: 16px;
  }

  > a {
    display: block;
    font-size: ${FONT_SIZE.S}px;
    color: ${COLOR.GRAY900.code};
    line-height: 1.6;

    ${mq.sp} {
      font-size: ${FONT_SIZE.XS}px;
    }
  }
`;

export const NavIconLink = styled.nav`
  display: flex;
  margin-bottom: 16px;
`;

export const AnchorIconLink = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 48px;
  height: 48px;
  &:nth-of-type(n + 2) {
    margin-left: 16px;
  }
`;

export const ParCopyright = styled.p`
  font-size: ${FONT_SIZE.XS}px;
  color: ${COLOR.GRAY500.code};

  ${mq.sp} {
    font-size: 10px;
  }
`;
